export const USER_INFO = 'USER_INFO'; // 用户信息
export const SHOP_INFO = 'SHOP_INFO'; // 店铺信息
export const ENTERPRISE_TYPE = 'ENTERPRISE_TYPE'; // 企业类型

export const DEVELOP_CUSTOMER_SERVICE_PARAMS = 'DEVELOP_CUSTOMER_SERVICE_PARAMS'; // 拓展顾问推广参数
